import React, { useEffect, useState } from 'react';

const Message = ({ variant, children }) => {
    return (
        <div className={`alert alert-${variant}`}>{children}</div>
    )
}

export default Message;
